export const ACCOUNTS_TRANSLATE = {
    accounts: {
        breadcrumbName: "Cuentas",
        messages: {
            create: "Cuenta creada exitosamente",
            update: "Cuenta actualizada exitosamente",
            delete: "Cuenta desactivada exitosamente",
            recover: "Cuenta restaurada exitosamente"
        },
        list: {
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Ingrese el ID",
                        url: "id"
                    },
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre",
                        url: "name"
                    },
                    email: {
                        label: "Correo electrónico",
                        placeholder: "Ingrese el correo electrónico",
                        url: "email"
                    },
                    active: {
                        label: "Estado",
                        placeholder: "Seleccione el estado",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Desactivar cuenta",
                    body: "¿Está seguro de que desea desactivar la cuenta con ID {{id}}?",
                    save: {
                        text: "Sí, desactivar"
                    },
                    back: {
                        text: "Volver"
                    },
                }
            },
            table: {
                columns: {
                    id: "ID",
                    name: "Nombre"
                }
            }
        },
        tabs: {
            general: "General",
            text: "Textos",
            users: "Usuarios",
            asks: "Preguntas",
            logo: "Logo",
            languages: "Idiomas"
        },
        dictionaries: {
            breadcrumb: "Diccionarios",
            messages: {
                create: "Diccionario creado exitosamente",
                update: "Diccionario actualizado exitosamente",
                delete: "Diccionario eliminado exitosamente",
                recover: "Diccionario restaurado exitosamente"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Idioma"
                    }
                },
                dialog: {
                    delete: {
                        title: "Eliminar diccionario",
                        body: "¿Está seguro de que desea eliminar el diccionario con ID {{id}}?",
                        save: {
                            text: "Sí, eliminar"
                        },
                        back: {
                            text: "Volver"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Idioma",
                            placeholder: "Seleccione el idioma"
                        },
                        welcomeMessage: {
                            label: "Mensaje de bienvenida",
                            placeholder: "Ingrese el mensaje de bienvenida aquí"
                        },
                        welcomeTerms: {
                            label: "Términos de uso",
                            placeholder: "Ingrese los términos de uso aquí"
                        },
                        choiceHelpText: {
                            label: "Mensaje para el botón \"¿No sabe cuál elegir?\"",
                            placeholder: "Ingrese el mensaje aquí"
                        },
                        helpText: {
                            label: "Mensaje para el botón \"Ayuda\"",
                            placeholder: "Ingrese el mensaje aquí"
                        }
                    }
                }
            }
        },

        save: {
            form: {
                fields: {
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre aquí"
                    },
                    uuid: {
                        label: "UUID",
                        placeholder: "Ingrese el UUID de la cuenta aquí"
                    },
                    welcomeTerms: {
                        label: "Términos de uso",
                        placeholder: "Ingrese los términos de uso aquí"
                    },
                    welcomeMessage: {
                        label: "Mensaje de bienvenida",
                        placeholder: "Ingrese el mensaje de bienvenida aquí"
                    },
                    choiceHelpText: {
                        label: "Mensaje para el botón \"¿No sabe cuál elegir?\"",
                        placeholder: "Ingrese el mensaje aquí"
                    },
                    helpText: {
                        label: "Mensaje para el botón \"Ayuda\"",
                        placeholder: "Ingrese el mensaje aquí"
                    },
                    generalChannelUrl: {
                        label: "URL de denuncia",
                        placeholder: "Ingrese la URL de denuncia aquí"
                    },
                    womenChannelUrl: {
                        label: "URL del canal de la mujer",
                        placeholder: "Ingrese la URL del canal de la mujer aquí"
                    },
                    showGeneralChannel: {
                        label: "Mostrar canal general"
                    },
                    showWomenChannel: {
                        label: "Mostrar canal de la mujer"
                    },
                    categoryIsOptional: {
                        label: "Categoría opcional",
                        placeholder: "Mientras esta opción esté marcada, el denunciante no está obligado a informar la categoría"
                    },
                    multipleLanguagesEnabled: {
                        label: "Permitir que el colaborador seleccione el idioma",
                        placeholder: "Si esta configuración está habilitada, un botón de selección de idioma será visible en la esquina superior de la pantalla"
                    },
                    logo: {
                        label: "Logo",
                        noResultsLabel: "Ninguna imagen agregada",
                        noResultsDescription: "",
                        textButton: "Agregar logo",
                        changeTextButton: "Cambiar logo",
                        hints: {
                            first: "La proporción ideal para el logo es 1500 x 700 (ancho x alto)",
                            second: "Formatos aceptados: .JPG, .JPEG, .PNG, .WEBP, .GIF"
                        }
                    }
                }
            }
        },

        languages: {
            messages: {
                activate: "Idioma activado exitosamente",
                inactivate: "Idioma desactivado exitosamente"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        name: "Nombre",
                        tag: "Tag"
                    }
                },
                dialog: {
                    activate: {
                        title: "Activar idioma",
                        body: "¿Está seguro de que desea activar el idioma \"{{name}}\"?",
                        save: {
                            text: "Sí, activar"
                        },
                        back: {
                            text: "Volver"
                        }
                    },
                    inactivate: {
                        title: "Desactivar idioma",
                        body: "¿Está seguro de que desea desactivar el idioma \"{{name}}\"?",
                        save: {
                            text: "Sí, desactivar"
                        },
                        back: {
                            text: "Volver"
                        }
                    }
                }
            }
        },

        asks: {
            messages: {
                create: "Pregunta agregada exitosamente",
                update: "Pregunta actualizada exitosamente",
                delete: "Pregunta eliminada exitosamente",
                recover: "Pregunta restaurada exitosamente"
            },
            list: {
                dialog: {
                    delete: {
                        title: "Eliminar pregunta",
                        body: "¿Está seguro de que desea eliminar la pregunta con ID {{id}}?",
                        save: {
                            text: "Sí, eliminar"
                        },
                        back: {
                            text: "Volver"
                        },
                    }
                },
                listActions: {
                    options: {
                        text: "Opciones de respuesta"
                    },
                    dictionaries: {
                        text: "Ver diccionario"
                    }
                },
                columns: {
                    title: "Título",
                    id: "ID",
                    required: "Obligatorio"
                }
            },
            create: {
                title: "Agregar pregunta"
            },
            update: {
                title: "Editar pregunta"
            },
            fields: {
                title: {
                    label: "Nombre del campo",
                    placeholder: "Ingrese el nombre del campo aquí"
                },
                required: {
                    label: "Campo obligatorio"
                }
            },
            dictionaries: {
                dialog: {
                    title: "Diccionarios de la Pregunta"
                },
                messages: {
                    create: "Diccionario creado exitosamente",
                    update: "Diccionario actualizado exitosamente",
                    delete: "Diccionario eliminado exitosamente",
                    recover: "Diccionario restaurado exitosamente"
                },
                create: {
                    title: "Agregar diccionario"
                },
                update: {
                    title: "Editar diccionario"
                },
                list: {
                    label: "Diccionarios",
                    columns: {
                        id: "ID",
                        language: "Idioma",
                        title: "Título"
                    },
                    dialog: {
                        delete: {
                            title: "Eliminar diccionario",
                            body: "¿Está seguro de que desea eliminar el diccionario con ID {{id}}?",
                            save: {
                                text: "Sí, eliminar"
                            },
                            back: {
                                text: "Volver"
                            }
                        }
                    }
                },
                save: {
                    form: {
                        fields: {
                            languageId: {
                                label: "Idioma",
                                placeholder: "Seleccione un idioma"
                            },
                            title: {
                                label: "Título de la pregunta",
                                placeholder: "Ingrese el título de la pregunta en este idioma"
                            }
                        }
                    }
                }
            },

            options: {
                messages: {
                    create: "Opción agregada exitosamente",
                    update: "Opción actualizada exitosamente",
                    delete: "Opción eliminada exitosamente",
                    recover: "Opción restaurada exitosamente"
                },
                create: {
                    title: "Agregar opción"
                },
                update: {
                    title: "Editar opción"
                },
                fields: {
                    title: {
                        label: "Título de la opción",
                        placeholder: "Ingrese el título de la opción aquí"
                    }
                },
                list: {
                    label: "Opciones",
                    columns: {
                        id: "ID",
                        title: "Título"
                    },
                    dialog: {
                        delete: {
                            title: "Eliminar opción",
                            body: "¿Está seguro de que desea eliminar la opción con ID {{id}}?",
                            save: {
                                text: "Sí, eliminar"
                            },
                            back: {
                                text: "Volver"
                            },
                        }
                    },
                    listActions: {
                        dictionaries: {
                            text: "Ver diccionario"
                        }
                    }
                },
                save: {
                    fields: {
                        title: {
                            label: "Título",
                            placeholder: "Ingrese el título de la opción aquí"
                        }
                    }
                },
                dictionaries: {
                    dialog: {
                        title: "Diccionarios de la Opción"
                    },
                    messages: {
                        create: "Diccionario creado exitosamente",
                        update: "Diccionario actualizado exitosamente",
                        delete: "Diccionario eliminado exitosamente",
                        recover: "Diccionario restaurado exitosamente"
                    },
                    create: {
                        title: "Agregar diccionario"
                    },
                    update: {
                        title: "Editar diccionario"
                    },
                    list: {
                        label: "Diccionarios",
                        columns: {
                            id: "ID",
                            language: "Idioma",
                            title: "Título"
                        },
                        dialog: {
                            delete: {
                                title: "Eliminar diccionario",
                                body: "¿Está seguro de que desea eliminar el diccionario con ID {{id}}?",
                                save: {
                                    text: "Sí, eliminar"
                                },
                                back: {
                                    text: "Volver"
                                }
                            }
                        }
                    },
                    save: {
                        form: {
                            fields: {
                                languageId: {
                                    label: "Idioma",
                                    placeholder: "Seleccione un idioma"
                                },
                                title: {
                                    label: "Título de la opción",
                                    placeholder: "Ingrese el título de la opción en este idioma"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
